import { useQuery, useMutation } from "@tanstack/react-query";
import { transferApiService } from "modules/Pharmacy/Transfer/api/transfer.api";
import { TransferFormValues } from "modules/Pharmacy/Transfer/helpers/transfer.types";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statuscode: number;
}

export const useTransferService = ({
  searchText,
  pageNumber = 1,
  pageSize,

  studyid,
  enableSelectall = false,
}: {
  searchText?: string | null;
  pageNumber?: number;
  pageSize?: number;

  studyid?: number | string | null;
  enableSelectall?: boolean;
} = {}) => {

  // SELECT ALL
  const SelectAllQuery = useQuery({
    queryKey: [
      "transfer-selectAll",
      { searchText, pageNumber, pageSize, studyid },
    ],
    queryFn: () =>
      transferApiService.getSelectAllData({
        searchtext: searchText ?? null,
        currentpage: pageNumber,
        pagesize: pageSize,
        status: "A",
     
        studyid: studyid ?? null,
      }),
      enabled: enableSelectall,
  });

  // DELETE
  const DeleteMutation = useMutation<ApiResponse, Error, { transferid: number | null, updatereason: string }>({
    mutationFn: (payload) =>
      transferApiService.deleteData(payload),
  });

  // INSERT
  const InsertMutation = useMutation({
    mutationFn: (payload: TransferFormValues) => transferApiService.insertData(payload),
  });

  // UPDATE
  const UpdateMutation = useMutation({
    mutationFn: (payload: TransferFormValues & { updatereason: string; }) => transferApiService.updateData(payload),
  });

  // SELECT BY ID
  const SelectIdQuery = (transferid: number | string | null) =>
    useQuery({
      queryKey: ["transfer-select", transferid],
      queryFn: () => transferApiService.getSelectData(transferid!),
      enabled: !!transferid,
    });

  const verifyPinMutation = useMutation({
    mutationFn: (payload: { verifypin: string, transferid: number, studyid: number, verifiedby: number }) => transferApiService.verifyPin(payload),
  });

  return { SelectAllQuery, InsertMutation, UpdateMutation, DeleteMutation, SelectIdQuery, verifyPinMutation };
};
